export default {"src":"/uk/_next/static/media/spot-phone.cdbf8a26.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};